import * as React from "react"
import {TextFieldSeeker} from "@ui-seeker/core"

import {useAdminBrandForm} from "../../@hooks"


export default function AdminBrandsDisplayNameTextField({ disabled }) {
	const { value, handleChange } = useAdminBrandForm('displayName')

    return <TextFieldSeeker
		label="Display Name"
		placeholder="Please provide a display name for this brand."
		value={value}
		disabled={disabled}
		onChange={e => handleChange(e.target.value)}
	/>
}